import {injectable} from 'inversify';

import {UserOnboardingModel} from './UserOnboarding.model';

@injectable()
export class UserOnboardingFactory {
  create(props: UserOnboardingModel.Props): UserOnboardingModel {
    return new UserOnboardingModel(props);
  }

  createEmpty(): UserOnboardingModel {
    return new UserOnboardingModel(UserOnboardingFactory.EMPTY_PROPS);
  }
}

export namespace UserOnboardingFactory {
  export const EMPTY_PROPS: UserOnboardingModel.Props = {
    answers: [],
    finished: null,
    type: 'internal',
  };
}
